import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Grid, Text, useMultiStyleConfig} from '@chakra-ui/react'

const GridTemplate = ({header, children, variant}) => {
    const styles = useMultiStyleConfig('GridTemplate', {variant})
    return (
        <Flex {...styles.container} data-testid="grid-template-container">
            <Text {...styles.header} data-testid="grid-template-header">
                {header}
            </Text>
            <Grid {...styles.gridSection} data-testid="grid-section">
                {children}
            </Grid>
        </Flex>
    )
}

GridTemplate.propTypes = {
    header: PropTypes.node,
    children: PropTypes.node,
    variant: PropTypes.string,
}

export default GridTemplate
